export interface ServicesTypeDataPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: ServicesType[];
}

export interface ServicesType {
  id_tipo_servicio?: string;
  nombre: string;
  descripcion?: string;

  // bool to set the correct plan and promotion
  discapacidad: boolean;
  tercera_edad: boolean;
}

export enum ServciceTypeEnum {
  FIBRA = 'FIBRA',
  WIRELESS = 'WIRELESS',
  RADIO = 'RADIO',
}

